export const FETCH_AGREEMENT_REQUEST = "FETCH_AGREEMENT_REQUEST";
export const FETCH_AGREEMENT_SUCCESS = "FETCH_AGREEMENT_SUCCESS";
export const FETCH_AGREEMENT_ERROR = "FETCH_AGREEMENT_ERROR";

export const EDIT_AGREEMENT_REQUEST = "EDIT_AGREEMENT_REQUEST";
export const EDIT_AGREEMENT_SUCCESS = "EDIT_AGREEMENT_SUCCESS";
export const EDIT_AGREEMENT_ERROR = "EDIT_AGREEMENT_ERROR";
